import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'
import { useUpdateUserMutation } from '../../../features/fullApi';
import { toast } from 'react-hot-toast';

export default function EditEmailDialog({openEmailModal, setOpenEmailModal, handleUpdateUser}) {

    const user = JSON.parse(localStorage.getItem('user'))
    const [updateUser] = useUpdateUserMutation()


    const onSubmit = async(values, actions) => {
          updateUser({_id: user._id, email: values.email }, { 
          headers: {
              'Token': `Bearer ${user?.accessToken}`
          }
          }, {id: user._id})
          .then(res => {
            toast.success('Successfully updated email')
            console.log("res is",res)
          })
          .catch((e) => {
          console.log("e is", e)
          })
      }
      
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          email: user?.email,
        },
        onSubmit,
      });

    return (
        <form onSubmit={handleSubmit} style={{width: '500px'}}>
            <Dialog fullWidth aria-labelledby='dialog-title' onClose={() => setOpenEmailModal(false)} open={openEmailModal}>
                <DialogTitle id='dialog-title'>
                    Change email
                </DialogTitle>
                <DialogContent>
                    <TextField
                        id="email"
                        type="text"
                        margin="dense"
                        fullWidth
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.email ? "" : "email"}
                    />
                    {errors.email && touched.email && (
                        <p className="error">{errors.email}</p>
                    )}
                    <p style={{color: 'red', fontWeight: 'bold'}}>Changing your email requires confirming your new email via confirmation link on the new email</p>
                </DialogContent>
                <DialogActions>
                  <Button
                          color="secondary"
                          onClick={() => 
                            {
                              toast('Canceled ✖');
                              values.email=user?.email
                              setOpenEmailModal(false)
                            }
                            }
                          variant="contained"
                      >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleUpdateUser({id: user._id, email: values.email})}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}